import React, { useEffect } from 'react';
import { NavItem } from '../types';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PlatformHero from '../components/platform/PlatformHero';
import PlatformFeatures from '../components/platform/PlatformFeatures';
import PlatformDemo from '../components/platform/PlatformDemo';
import PlatformTestimonials from '../components/platform/PlatformTestimonials';
import Contact from '../components/home/Contact';

const PlatformPage = () => {
  useEffect(() => {
    document.title = 'DriversOnCall - HandsForNeeds PVT LTD';
    
    // Add meta description for SEO
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'DriversOnCall by HandsForNeeds PVT LTD provides on-demand professional drivers for all your transportation needs. Book reliable, verified drivers anytime, anywhere.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'DriversOnCall by HandsForNeeds PVT LTD provides on-demand professional drivers for all your transportation needs. Book reliable, verified drivers anytime, anywhere.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);
  
  // Define navigation items
  const navItems: NavItem[] = [
    { title: 'Home', href: '/' },
    { title: 'Features', href: '#features' },
    { title: 'Demo', href: '#demo' },
    { title: 'Testimonials', href: '#testimonials' },
    { title: 'Contact', href: '#contact' }
  ];
  
  // Add CSS for fade-in animation
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .animate-fade-in {
        animation: fadeIn 1s ease forwards;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>
      <Navbar navItems={navItems} />
      <main>
        <PlatformHero />
        <div id="features">
          <PlatformFeatures />
        </div>
        <div id="demo">
          <PlatformDemo />
        </div>
        <div id="testimonials">
          <PlatformTestimonials />
        </div>
        <div id="contact">
          <Contact />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PlatformPage;